import Link from 'next/link';
import Image from 'next/image';
import { FC } from 'react';
import HomeAuthButton from './HomeAuthButton';
import HomeMenuIcon from './HomeMenuIcon';
import ToggleMenuButton from '@/app/(public_pages)/HomeToggleMenuButton.client';

const HomeNavHeader: FC = () => {

  return (
    <div className='w-full lg:pl-12'>
      <nav className="nav-container mt-2">
        <Link href="/" className="logo-link block pt-[9px] md:pt-[4px]">
          <img
            src='/assets/images/logo1.png'
            alt="Logo"
            className="logo-fade show w-[300px] md:w-[450px] mb-2"
          />
        </Link>

        <div className="home-nav-links hidden lg:block" id="navLinks">
         
          <ul className="home-nav-list hidden lg:block">
            {[
              ['HOME', '/'],
              ['ABOUT US', '/about'],
              ['ACADEMICS', '/academics'],
              ['PUBLICATIONS', '/publications'],
              ['NEWS', '/news'],
              ['GALLERY', '/gallery'],
              ['CONTACT US', '/contact'],
            ].map(([title, url]) => (
              <li key={title} className="nav-item ">
                <Link href={url} className="home-nav-link text-[#0963b8] text-[13px]">
                  {title}
                </Link>
              </li>
            ))}
            <li className="nav-item no-hover">
              <HomeAuthButton />
            </li>
          </ul>
        </div>

        <div className='block lg:hidden -mr-7 md:-mr-7'>
          <ToggleMenuButton/>
        </div>
      </nav>
    </div>
  );
};

export default HomeNavHeader;